import { gql } from '@reverbdotcom/commons/src/gql';
import I18n from 'i18n-js';
import React from 'react';
import moment from 'moment';

import { Item2StatsDataFragment } from '@reverbdotcom/commons/src/gql/graphql';
import { isCoreBrandNew } from '@reverbdotcom/commons/src/condition_helpers';
import { isDigital } from '@reverbdotcom/commons/src/listing_helpers';

interface IProps {
  listing: Item2StatsDataFragment;
}

export const Item2StatsFragment = gql(`
  fragment Item2StatsData on Listing {
    _id
    id
    hasInventory
    condition {
      conditionUuid
    }
    publishedAt {
      seconds
    }
    listingType
    counts {
      id
      viewsDisplay
      offersDisplay
      watchersDisplay
      downloadCountDisplay
    }
    offersEnabled
  }
`);

export function Item2Stats({ listing }: IProps) {
  const isNew = isCoreBrandNew(listing.condition.conditionUuid);
  const isInventoried = listing.hasInventory;
  const showDownloadCount = isDigital(listing) && !!listing.counts?.downloadCountDisplay;

  function dateListedText() {
    const date = moment.unix(listing.publishedAt?.seconds);
    if (!(isNew || isInventoried)) {
      return date.fromNow();
    }
    // moment switches from 1 month to 2 months after 45 days
    if (moment().diff(date, 'days') >= 45) {
      return I18n.t('discovery.item2Description.overAMonthAgo');
    }
    return date.fromNow();
  }

  return (
    <div className="item2-stats">
      {listing.publishedAt &&
        <div className="item2-stats__stat-block">
          <span className="weight-bold mr-space">
            {I18n.t('discovery.item2Description.listed')}:
          </span>
          {dateListedText()}
        </div>
      }
      <div className="item2-stats__stat-block">
        <span className="weight-bold mr-space">
          {I18n.t('discovery.item2Description.views')}:
        </span>
        {listing.counts?.viewsDisplay}
      </div>
      <div className="item2-stats__stat-block">
        <span className="weight-bold mr-space">
          {I18n.t('discovery.item2Description.watchers')}:
        </span>
        {listing.counts?.watchersDisplay}
      </div>
      {listing.offersEnabled &&
        <div className="item2-stats__stat-block">
          <span className="weight-bold mr-space">
            {I18n.t('discovery.item2Description.offers')}:
          </span>
          {listing.counts?.offersDisplay}
        </div>
      }
      {showDownloadCount &&
        <div className="item2-stats__stat-block">
          <span className="weight-bold mr-space">
            {I18n.t('discovery.item2Description.downloads')}:
          </span>
          {listing.counts?.downloadCountDisplay}
        </div>
      }
    </div>
  );
}
